<div [ngStyle]="specialStyle" *ngIf="active" [style.height]="'100%'">
	<ng-content></ng-content>
</div>
